// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'inte... Remove this comment to see the full error message
import Interframe from 'interframe';
import { EventActions } from './constants';
/**
 * EventBus create an Interframe messenger to send and receive
 * messages over postMessage. Each message is sent with the unique ID
 * and each message received must match that same ID.
 */
export default class EventBus {
  constructor(props) {
    this.onPostMessage = message => {
      if (!message) return;
      const {
        action,
        id,
        payload
      } = message;
      if (id !== this.id) return;
      const actionExecutor = this.events[action];
      if (actionExecutor) {
        actionExecutor(payload);
      }
    };
    const {
      id: _id
    } = props;
    this.id = _id;
    this.events = {};
    this.connected = false;
  }
  connect(targetOrigin, targetWindow) {
    this.messenger = new Interframe(targetOrigin, targetWindow);
    this.messengerSubscription = this.messenger.subscribe(this.onPostMessage);
    this.connected = true;
  }
  isConnected() {
    return this.connected;
  }
  postMessage(message, callback) {
    if (this.messenger) {
      return this.messenger.postMessage(Object.assign({}, message, {
        id: this.id
      }), callback);
    }
    return null;
  }
  on(action, callback) {
    this.events[action] = callback;
  }
  disconnect() {
    if (this.messengerSubscription) this.messengerSubscription.unsubscribe();
    if (this.messenger) this.messenger.destroy();
    this.connected = false;
  }
}